import { Person } from "@mui/icons-material";
import Profile from "../Profile";
import Settings from "../Settings";
import SettingsIcon from "@mui/icons-material/Settings";
export const titles = ["Profile", "Settings"];
export const content = [<Profile />, <Settings />];
export const icons = [<Person />, <SettingsIcon />];
export const testIds = [
  "profile.page.tab.my-profile",
  "profile.page.tab.preferences",
];
